import styled from 'styled-components'
import { BqCheckbox, BqDialog } from '@beeq/react'

export const StyledBqDialog = styled(BqDialog)`
    --bq-dialog--title-body-gap: var(--bq-spacing-l)
`

export const StyledContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--bq-spacing-l);
`

export const StyledHelperTextWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: var(--bq-spacing-xs);
`

export const StyledCheckboxList = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--bq-spacing-xs);
`

export const StyledFieldset = styled.fieldset`
    max-height: 296px;
    padding: var(--bq-spacing-s) var(--bq-spacing-xs) var(--bq-spacing-s) var(--bq-spacing-m);
    border-width: var(--bq-stroke-s);
    border-style: solid;
    border-color: var(--bq-stroke--secondary);
    border-radius: var(--bq-radius--s);
`

export const StyledPermissionsWrapper = styled.div`
    overflow: auto;
    display: flex;
    flex-direction: column;
    height: 100%;
    gap: var(--bq-spacing-xs);
`

export const StyledBqCheckbox = styled(BqCheckbox)`
    --bq-checkbox--size: 21px;
    width: 100%;

    &::part(base){
        padding: var(--bq-spacing-xs2) var(--bq-spacing-xs);
    }
`

export const StyledPermissionHelperText = styled.div`
    color: var(--bq-text--danger);
    display: flex;
    align-items: center;
    gap: var(--bq-spacing-xs);
`

export const StyledFooter = styled.footer`
    display: flex;
    justify-content: flex-end;
    gap: var(--bq-spacing-xs);
`
